(function () {
  function parseValue(str) {
    if (!str || typeof str !== 'string') return null;
    var m = str.match(/^([+\-\s]*)(\d+)(.*)$/);
    if (!m) return null;
    return { prefix: m[1], target: parseInt(m[2], 10), suffix: m[3] || '' };
  }

  function easeOutQuart(t) {
    return 1 - Math.pow(1 - t, 4);
  }

  function animateCounter(el) {
    var raw = el.getAttribute('data-value');
    var parsed = parseValue(raw);
    if (!parsed || parsed.target === 0) return;
    el._counterDone = true;
    var start = 0;
    var startTime = null;
    var duration = 1500;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeOutQuart(progress);
      var current = Math.round(parsed.target * eased);
      el.textContent = parsed.prefix + current + parsed.suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = parsed.prefix + parsed.target + parsed.suffix;
    }
    requestAnimationFrame(step);
  }

  function initCounters(container) {
    if (!container) return;
    var els = container.querySelectorAll('.nw-effectiveness-card__percentage[data-value]:not([data-counter-done])');
    els.forEach(function (el) {
      if (el._counterDone) return;
      animateCounter(el);
      el.setAttribute('data-counter-done', '');
    });
  }

  function observeSection(section) {
    if (!section) return;
    var percentageEls = section.querySelectorAll('.nw-effectiveness-card__percentage[data-value]');
    if (!('IntersectionObserver' in window)) {
      initCounters(section);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el._counterDone || el.hasAttribute('data-counter-done')) return;
          animateCounter(el);
          el.setAttribute('data-counter-done', '');
          observer.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.2 }
    );
    percentageEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function run() {
    document.querySelectorAll('.nw-effectiveness-main').forEach(observeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
